import React from "react";
import { Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import t from "@constants/localization";
import ScalableText from "./ScalableText";
import { submitPoll } from "../../../services/api";
import { getData, setData } from "../../../lib/storage";
import metrics from "../../../constants/metrics";

const PATH = "screens/Story";

const MultiPoll = (props) => {
  const {
    id = "",
    header = "",
    header_color = "white",
    answers = [
      {
        answer: "",
        answer_color: "green",
      },
      {
        answer: "",
        answer_color: "green",
      },
    ],

    pauseStory = () => {},
    unpauseStory = () => {},
    submitted,
    setSubmitted,
    trackEvent = () => {},
  } = props;

  const onSubmit = (answerId) => () => {
    trackEvent({ pollId: id, answerId });
    submitPoll({ pollId: id, answerId })
      .then(async () => {
        setSubmitted((s) => [...s, id]);
        const submittedPolls = (await getData("cmsSubmittedPolls")) ?? [];
        await setData("cmsSubmittedPolls", [...submittedPolls, id]);
      })
      .catch((err) => console.log(err));
  };
  return (
    <View
      style={{
        flex: 1,
        alignSelf: "center",
        position: "absolute",
        zIndex: 10,
        width: metrics.screenWidth - 80,
        left: 40,
      }}
    >
      <Text
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          color: header_color ?? "white",
          fontSize: 24,
          textAlign: "center",
          marginBottom: 20,
        }}
      >
        {header}
      </Text>

      {submitted ? (
        <View
          style={{
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginBottom: 6,
          }}
        >
          <Text style={{ textAlign: "center", fontSize: 16, opacity: 0.56 }}>
            {t(`${PATH}/youHaveAnswered`)}
          </Text>
        </View>
      ) : (
        <View>
          {Array.isArray(answers) &&
            answers.map(({ answer, answer_color, id: answerId }) => (
              <TouchableOpacity
                key={answerId}
                activeOpacity={0.9}
                disabled={submitted}
                onPressIn={pauseStory}
                onPressOut={unpauseStory}
                onPress={onSubmit(answerId)}
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 10,
                  marginBottom: 6,
                }}
              >
                <ScalableText
                  fontSize={22}
                  minSize={14}
                  numberOfLines={2}
                  style={{
                    textAlign: "center",
                    color: answer_color ?? "black",
                    fontFamily: "Muli-SemiBold",
                  }}
                >
                  {answer}
                </ScalableText>
              </TouchableOpacity>
            ))}
        </View>
      )}
    </View>
  );
};

export default MultiPoll;
